<template>
  <fullpageform
    title="Edit Farm"
    submitLabel="Save"
    cancelLabel="Cancel"
    @submit="submit"
    @cancel="cancel"
    :hasValidation="true"
  >
    <fieldset>
      <label for="farm_name">Name</label>
      <br />
      <input type="text" id="farm_name" v-model.trim="name" ref="name" @input="showError = false" />
      <span v-if="showError" class="error-message">Invalid Farm Name</span>
      <br />
      <label for="remove_farm" type="button">Remove Farm</label>
      <br />
      <icon-button type="button" id="remove_farm" fa-icon="fa-trash" @click="removeFarm()" />
    </fieldset>
  </fullpageform>
</template>

<script>
export default {
  props: ['farm'],
  data: function () {
    return {
      name: null,
      showError: false
    }
  },
  watch: {
    name(newValue) {
      if (newValue.trim()) {
        this.showError = false
      }
    }
  },
  methods: {
    submit: async function () {
      if (!this.name?.trim()) {
        this.showError = true
        return
      }

      let modifiedFarm = JSON.parse(JSON.stringify(this.farm))
      modifiedFarm.name = this.name

      let patch = {
        op: 'name' in this.farm ? 'replace' : 'add',
        path: '/name',
        value: this.name
      }

      this.$store.dispatch('patchSelectedFarm', patch)

      this.$dialog.pop()
    },
    cancel: function () {
      this.$dialog.pop()
    },
    async removeFarm() {
      const doTheRemove = async () => {
        await this.$store.dispatch('removeSelectedFarm')
        this.$dialog.pop()
        this.$router.replace({ name: 'Home', params: {} })
      }
      this.$dialog.confirm(doTheRemove)
    },
    updateData() {
      this.name = this.farm.name
    }
  },
  mounted: function () {
    this.updateData()
  }
}
</script>

<style>
.error-message {
  color: red;
  font-size: 0.8em;
  margin-top: 0.2em;
  display: block;
}
</style>
